/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { architectsControllerCreate } from "./architectsControllerCreate";
import { architectsControllerFindAll } from "./architectsControllerFindAll";
import { architectsControllerFindOne } from "./architectsControllerFindOne";
import { architectsControllerRemove } from "./architectsControllerRemove";
import { architectsControllerUpdate } from "./architectsControllerUpdate";

export function architectsService() {
  return { architectsControllerCreate, architectsControllerFindAll, architectsControllerFindOne, architectsControllerUpdate, architectsControllerRemove }
}